
// Vue reactivity
import { computed } from 'vue';

// components
import { IonPage, IonGrid, IonHeader, IonToolbar, IonTitle, IonContent,
        IonSpinner, IonList, IonButtons, IonBackButton, } from '@ionic/vue';

// composables
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export default {
  name: 'TermsAndConditionsPage',
  components: { IonPage, IonGrid, IonHeader, IonToolbar, IonTitle, IonContent,
                IonSpinner, IonList, IonButtons, IonBackButton,
                },
  setup() {
    const store = useStore();

    // 1. declare state variables (ref to make them reactive)
    const settings = computed(() => store.state.settings);

    // methods or filters
    const { t } = useI18n();

    // 3. return variables & methods to be used in template HTML
    return {
      // methods
      t,

      // variables
      settings,
    }
  }
}
